export default "__VITE_ASSET__CxKQHscr__"